import {Bar} from '@visx/shape';
import {css, StyleSheet} from 'aphrodite';
import React, {SVGProps} from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';

type PolymerSearchResultRegionProps = SVGProps<SVGRectElement> & {
  xFn: (index: number) => number;
  regionStartIndex: number;
  regionLength: number;
  isSelected: boolean;
  onClick: () => void;
};

export default function PolymerSearchResultRegion({
  xFn,
  regionStartIndex,
  regionLength,
  isSelected,
  onClick,
  ...svgRectProps
}: PolymerSearchResultRegionProps): JSX.Element {
  return (
    <Bar
      className={css(styles.resultRegionRect)}
      x={xFn(regionStartIndex)}
      width={xFn(regionStartIndex + regionLength) - xFn(regionStartIndex)}
      fill={isSelected ? 'orange' : 'yellow'}
      fillOpacity={0.4}
      stroke="black"
      strokeWidth={1}
      onClick={onClick}
      {...getTestProps({component: 'PolymerSearchResultRegion', element: 'root'})}
      {...svgRectProps}
    />
  );
}

const styles = StyleSheet.create({
  resultRegionRect: {
    cursor: 'pointer',
  },
});
